module.exports = __webpack_public_path__ + "img/pic.028afaa0.png";